var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeldrHz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1444.16 540.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M501.4,394.4c-19.3-15.8-46-23.5-81.8-23.5-41.9,0-73.3,12.3-93.2,36.6-16.1,19.6-24.2,46.8-24.2,80.8,0,27.9,8.3,49,24.5,62.9,13.7,11.7,32.6,17.6,56,17.6a80.75,80.75,0,0,0,80.6-80.6,16.4,16.4,0,0,0-32.8,0,48,48,0,0,1-47.9,47.9c-33.6,0-47.9-14.3-47.9-47.9,0-26.2,5.7-46.4,16.8-60,13.4-16.4,36.2-24.6,67.9-24.6,27.9,0,47.9,5.3,61.1,16.1,15.9,13,23.6,35.5,23.6,68.6,0,58.7-7.2,90.9-24.7,111.4-12.7,14.7-39,34.3-120.9,34.3-44.5,0-77.5-11.5-100.7-35-47.7-48.4-46.4-141.5-45.3-216.3.2-11.1.3-21.6.3-31.7a144.28,144.28,0,0,1,7.7-46.7l112.8,37.1a19.65,19.65,0,0,0,25.8-18.6v-4.1a19.61,19.61,0,0,1,25.8-18.6l123.3,40.6c14,4.6,28.1-7.3,25.5-21.8-14.7-83-87.3-146.1-174.5-146.1h-.6c-98.4,0-178.4,80-178.4,178.4,0,9.9-.2,20.2-.3,31.2-1.2,80.9-2.6,181.6,54.7,239.7,29.3,29.7,71,44.8,124,44.8,73.6,0,118.6-14.1,145.7-45.7,17-19.7,32.6-49.5,32.6-132.7C537,445.4,525,413.8,501.4,394.4Z",
    transform: "translate(-179.54 -126.14)",
    style: {
      fill: "#00e676"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.1,271.4c-12.9-77-90.5-137.5-187.4-145.2a19.55,19.55,0,0,0-21,19.6V274.4A19.63,19.63,0,0,0,450.3,294H619.7A19.54,19.54,0,0,0,639.1,271.4Zm-91.4-24.6a27.1,27.1,0,1,1,27.1-27.1A27.12,27.12,0,0,1,547.7,246.8Z",
    transform: "translate(-179.54 -126.14)",
    style: {
      fill: "#1426ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.7,187.6v86.8A19.63,19.63,0,0,0,450.3,294h77.2A178,178,0,0,0,430.7,187.6Z",
    transform: "translate(-179.54 -126.14)",
    style: {
      fill: "#001276"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.9,483.2c-10.1-5-23.6-7.5-40.7-7.5a131.19,131.19,0,0,0-25.8,2.5,114.89,114.89,0,0,0-24.8,7.7c-2.9,1.3-5.7,2.7-8.5,4.2a55.26,55.26,0,0,0-10.4-6.9c-10.1-5-23.6-7.5-40.7-7.5a180.61,180.61,0,0,0-19.5,1.1,171.17,171.17,0,0,0-19,3.2,147.44,147.44,0,0,0-18.3,5.4,168.84,168.84,0,0,0-17.4,7.5V654h25.3V505.5a192.23,192.23,0,0,1,23.5-5.3,146,146,0,0,1,22.5-1.8c10.5,0,19,1.3,25.3,4s11,6.2,14,10.5a37.16,37.16,0,0,1,6.1,13.5,58.06,58.06,0,0,1,1.6,13.3V654h25.3V539.9c0-11.2-1.6-21-4.7-29.5a83.19,83.19,0,0,1,20.1-8.8,85.45,85.45,0,0,1,22.5-3.2c10.5,0,19,1.3,25.3,4s11,6.2,14,10.5a37.16,37.16,0,0,1,6.1,13.5,58.06,58.06,0,0,1,1.6,13.3V654h25.3V539.9c0-13.6-2.3-25.2-6.8-34.8S897.9,488.2,887.9,483.2Z",
    transform: "translate(-179.54 -126.14)",
    style: {
      fill: "#001276"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.5,522.3c-4.9-14.3-13-25.6-24.4-34.1s-26.4-12.6-45.1-12.6q-35.85,0-56.3,22.6t-20.5,67.9q0,30.9,9.8,51.6c6.6,13.8,15.9,24.2,28.1,31.1s26.6,10.4,43.2,10.4a165.69,165.69,0,0,0,33.5-3.2,121.75,121.75,0,0,0,27.9-9.1v-26a104.93,104.93,0,0,1-16.1,7.7,106.24,106.24,0,0,1-20,5.4,136.24,136.24,0,0,1-23.9,1.9c-18,0-32-5.6-42-16.7s-14.9-27.3-14.9-48.6h127.8C1117.7,552.8,1115.4,536.6,1110.5,522.3Zm-115.2,4.8c3.7-10.4,9.4-17.7,17-21.9s17.1-6.3,28.6-6.3c16.6,0,29,4.3,37,13,7.5,8.1,11.8,20,13,35.8h-100A91.05,91.05,0,0,1,995.3,527.1Z",
    transform: "translate(-179.54 -126.14)",
    style: {
      fill: "#001276"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 985.36,
    y: 285.96,
    width: 25.3,
    height: 241.9,
    style: {
      fill: "#001276"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.6,486.1c-2.5-.9-5.2-1.9-8.1-2.8a209.27,209.27,0,0,0-20.7-5.3,95,95,0,0,0-18.3-2.1q-40.35,0-60.2,23.7T1237.5,564c0,20.1,2.6,36.5,7.9,49s12.1,22.1,20.4,28.8a70.78,70.78,0,0,0,26.5,13.7,103.84,103.84,0,0,0,26.7,3.7,147.86,147.86,0,0,0,23.2-1.9,121.35,121.35,0,0,0,23.2-6c7.3-2.7,13.2-6.3,17.7-10.9a22.55,22.55,0,0,0,6.8-16.7v-219h-25.3v81.4Zm0,135.2q0,6.3-13.5,10.5t-31.8,4.2q-22.8,0-34.8-10.2c-8-6.8-13.3-15.6-16.1-26.5a141.17,141.17,0,0,1-4.2-35.3q0-19.35,5.4-33.9a47.3,47.3,0,0,1,17.2-22.8c7.8-5.5,18.1-8.2,30.7-8.2a101.23,101.23,0,0,1,23.7,3,86.05,86.05,0,0,1,23.3,9.3V621.3Z",
    transform: "translate(-179.54 -126.14)",
    style: {
      fill: "#001276"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1623.7,654l-63.6-97.1a60.26,60.26,0,0,0,21.1-7.9,63.28,63.28,0,0,0,23.5-24.9c5.6-10.5,8.4-22.6,8.4-36.2,0-22.5-5.8-39.4-17.4-50.9s-28.8-17.2-51.8-17.2h-96.2V654H1473V559.6h59.7l61.1,94.4ZM1473.1,443.7h68.1c18,0,30.3,4.2,36.9,12.5s9.8,19.5,9.8,33.5q0,22.5-13.2,34.2c-8.8,7.8-22.9,11.8-42.3,11.8h-59.3Z",
    transform: "translate(-179.54 -126.14)",
    style: {
      fill: "#001276"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeldrHz);
export default __webpack_public_path__ + "static/media/meldr-hz.272fa8bad738f9f6e9ee485fb35c49e0.svg";
export { ForwardRef as ReactComponent };